// extracted by mini-css-extract-plugin
module.exports = {"initial-tips":"antd-pro-pages-home-salary-private-settings-index-initial-tips","password-row":"antd-pro-pages-home-salary-private-settings-index-password-row"};